<div class="outer_card">
    <div class="card order-container" style="margin: 0;">
        <!-- card-body -->
        <div class="">
            <div class="row order-title-container">
                <span class="col-lg-6 col-sm-6 col-md-6 title_five my-2">Recent Activity</span>
                <div class="col-lg-6 col-sm-6 col-md-6 text-right my-2">
                    <app-column-chooser [table]="dataTable"></app-column-chooser>
                </div>
            </div>


            <div class="my-2">
                <app-data-table
                    #dataTable
                    [columnChooser]="true"
                    [columns]="columns"
                    [data]="recentActivities"
                    [totalRecords]="totalRecords"
                    [rows]="5"
                    [paginator]="true"
                    (pageChange)="onPageChange($event)">
                    <ng-template appTableCell="status" let-row>
                        <span style="color: #E09007;" *ngIf="row.status == 'Pending'; else showElse">{{ row.status }}</span>
                        <ng-template #showElse><span style="color: #E81200;">{{ row.status }}</span></ng-template>
                    </ng-template>

                    <ng-template appTableCell="action" let-row>
                        <div class="row">
                            <div class="col-lg-6"><i class='bx bx-edit bx-sm'></i></div>
                        </div>
                    </ng-template>
                </app-data-table>
            </div>

        </div>
    </div>
</div>